var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-component border-top",class:{
    'border-3 border-primary': !_vm.$store.state.setting.setting.setting_themes
      .theme_type
  },style:(_vm.title_background)},[_c('div',{class:("border-start-xl border-end-xl py-1 px-3 " + _vm.customClass),style:(_vm.title_color)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }